import { Component, OnInit, Inject } from '@angular/core';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';
import { Observable } from 'rxjs';
import { MatSnackBar } from '@angular/material/snack-bar';
import { CadastroService } from '../../../../../shared/services/cadastro.service';
import { FinancCCService } from '../../../../../shared/services/financ-cc.service';
import { Cadastro } from '../../../../../shared/interfaces/cadastro';
import { FinancRp } from '../../../../../shared/interfaces/financ-rp';
import { FatDoctoIProjection } from '../../../../../shared/interfaces/fat-docto-i-projection';
import { PageResult } from '../../../../../shared/interfaces/page-result';
import { HttpErrorResponse } from '@angular/common/http';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { debounceTime, tap, switchMap, finalize, catchError } from 'rxjs/operators';
import { AppLoaderService } from '../../../../../shared/services/app-loader/app-loader.service';
import { TransacaoService } from '../../../../../shared/services/transacao.service';
import { AppConfirmService } from '../../../../../shared/services/app-confirm/app-confirm.service';
import { FatDoctoI } from '../../../../../shared/interfaces/fat-docto-i';
import { Router } from '@angular/router';
import { FinancRpBaixa } from '../../../../../shared/interfaces/financ-rp-baixa';


@Component({
  selector: 'app-financ-rp-baixas',
  templateUrl: './financ-rp-baixas.component.html',
  styleUrls: ['./financ-rp-baixas.component.scss']
})
export class FinancRpBaixasComponent implements OnInit {

  baixa: FinancRpBaixa[];

  
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<FinancRpBaixasComponent>,
    private confirmService: AppConfirmService,
    private router: Router
    
  ) { }

  ngOnInit() {
    console.log(this.data.payload);
    this.baixa = this.data.payload;

    console.log(`baixa ${JSON.stringify(this.baixa)}`);

  }

 
  submit() {
    this.confirmService.confirm({ message: `Deseja realmente Fechar ?` })
    .subscribe(res => {
      if (res) {
        this.dialogRef.close();
      }
    }); 
  }

  editProduto(row: any){
    this.router.navigateByUrl(`/produto_detail/${row.idFatProdutoId}`);
    this.dialogRef.close();
  }

  



}
